import { render, staticRenderFns } from "./BetIndex.vue?vue&type=template&id=0c260e08&"
import script from "./BetIndex.vue?vue&type=script&lang=js&"
export * from "./BetIndex.vue?vue&type=script&lang=js&"
import style0 from "./BetIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BetIndex.vue"
export default component.exports